import { SvgIconProps } from "@mui/material";
import SvgIcon from "@mui/material/SvgIcon";

export const IconDownload = (props: SvgIconProps) => (
    <SvgIcon {...props} viewBox="0 0 24 24">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M3 10V18.004C3 18.554 3.4014 19 3.8964 19H20.1036C20.5986 19 21 18.554 21 18.004V10"
                stroke="#333333"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M12 14V5" stroke="#333333" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M8 12L12 14L16 12" stroke="#333333" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    </SvgIcon>
);
